import usePreference from "./usePreference";

const useServerInfo = () => {
  const { serverInfo } = usePreference();
  return serverInfo;
};

export default useServerInfo;
